<template>
  <div class="test-setting">
    <div class="info-line">
      <content-box class="info-box" :height="'50px'">
        <div class="test-count">
          {{$t('testSetting.testCount')}} :
          <div class="select-count">
            {{ selectedItem.length }}
          </div>
        </div>
      </content-box>
      <div class="btn-run">
        <ui-button
            :size="'large'"
            :primary="true"
            :disabled="btnDisabled"
            @click="runClick">{{ runCheck ? $t('testSetting.running') : $t('testSetting.runButton') }}</ui-button>
      </div>
    </div>
    <content-box class="table-wrap">
      <div class="thead">
        <table>
        <colgroup>
          <col>
          <col style="width: 10.5%">
          <col style="width: 10.5%">
          <col style="width: 18.5%">
          <col style="width: 47.5%">
          <col>
          <col>
        </colgroup>
        <thead>
          <tr>
            <th class="gap"></th>
            <th v-for="column in useHeaders" :key="`${column.value}`"
                :class="`th-${column.value}`"
                @click="changeSort(column.value)">
              <span v-if="column.value === 'testKey'"
                    @click.stop="onSelectAllItem">
                  <i v-if="selectedCount === 1"
                     class="icon icon--chkbox-on"></i>
                  <i v-else-if="selectedCount === 0"
                     class="icon icon--chkbox-half"></i>
                  <i v-else-if="selectedCount === -1"
                     class="icon icon--chkbox-black"></i>
              </span>
              {{column.name}}
              <button class="sort" v-if="column.value !== 'description'"
                      :class="{ active: testList.length && computedSort === column.value,
                                    asc: order,
                                    desc: !order }">
                <i class="icon icon--sort-asc"></i>
                <i class="icon icon--sort-desc"></i>
              </button>
            </th>
            <th class="gap"></th>
          </tr>
        </thead>
      </table>
      </div>
      <div class="tbody">
        <table>
          <tbody>
          <tr v-for="item in testList" :key="item.id">
            <td class="gap"></td>
            <td style="width: 10.5%">
              <div class="td-data" :class="{checkbox: true}">
              <ui-checkbox
                          :value="selectedItem.includes(item.id)"
                           @input="onSelectItem(item.id)"/>
                {{item.testKey}}
              </div>
            </td>
            <td style="width: 10.5%">
              <div class="td-data" :class="'state'">
                {{stateCheck(item.id)}}
                <svg v-if="stateCheck(item.id)" class="circular-loader" viewBox="25 25 50 50" >
                  <circle class="loader-path" cx="50" cy="50" r="20" fill="none" stroke="#70c542" stroke-width="2" />
                </svg>
              </div>
            </td>
            <td style="width: 18.5%"><div class="td-data">{{item.title}}</div></td>
            <td style="width: 47.5%"><div class="td-data">{{item.description}}</div></td>
            <td><div  class="td-data">{{dateTimeToDateStr(item.updatedAt)}}</div></td>
            <td class="gap"></td>
          </tr>
        </tbody>
        </table>
      </div>
    </content-box>

    <Dimmed v-if="runAlert">
      <alert :icon="'icon--alert'"
             :title="$t('testSetting.runAlert.title')"
             :description="$t('testSetting.runAlert.description')"
             :submit="$t('common.confirm')"
             @onSubmit="alertSubmit"/>
    </Dimmed>
  </div>

</template>


<script>
import ContentBox from "@/components/ui/ContentBox.vue"
import UiButton from "@/components/ui/UiButton.vue"
import UiCheckbox from "@/components/ui/UiCheckbox.vue";
import Alert from "@/components/ui/Alert.vue"
import Dimmed from "@/components/ui/Dimmed.vue";
import {probeRunCheck, getTestList, scenarioRun} from "@/api/probe"
import { format } from 'date-fns'

export default {
  name: 'TestSetting',
  components: {
    Dimmed,
    Alert,
    ContentBox,
    UiButton,
    UiCheckbox
  },
  created () {
    this.load()
  },
  computed: {
    selectedCount () {
      if (this.testList.length && this.selectedItem.length >= this.testList.length) {
        return 1
      } else if (this.selectedItem.length > 0) {
        return 0
      } else {
        return -1
      }
    },
    order () {
      return !this.listOption.sort.includes('-')
    },
    btnDisabled () {
      if (this.runCheck || this.selectedItem.length == 0) {
        return true
      } else {
        return false
      }
    },
    computedSort () {
      return this.listOption.sort.replace('-', '')
    }
  },
  methods: {
    stateCheck (id) {
      const runState = this.targetList.includes(id)
      if (runState) {
        return this.$t('testSetting.stateRun')
      } else {
        return null
      }
    },
    dateTimeToDateStr (datetime) {
      const dateObj = new Date(datetime)
      return format(dateObj, 'YYYY-MM-DD')
    },
    changeSort (sort) {
      if (sort !== 'description') {
        if (this.listOption.sort === '-' + sort) {
          this.listOption.sort = sort
        } else {
          this.listOption.sort = '-' + sort
        }
        this.sortInList()
      }
    },
    sortInList () {
      this.testList.sort((a, b) => {
        if (typeof a[this.computedSort] === 'string' && typeof b[this.computedSort] === 'string') {
          if (this.order) {
            // return a[this.computedSort].toString().localeCompare(b[this.computedSort].toString())
            return new Intl.Collator('en').compare(a[this.computedSort].toString(), b[this.computedSort].toString())
          } else {
            // return b[this.computedSort].toString().localeCompare(a[this.computedSort].toString())
            return new Intl.Collator('en').compare(b[this.computedSort].toString(), a[this.computedSort].toString())
          }
        } else {
          if (this.order) {
            return a[this.computedSort] > b[this.computedSort] ? 1 : -1
          } else {
            return b[this.computedSort] > a[this.computedSort] ? 1 : -1
          }
        }
      })
    },
    alertSubmit() {
      this.runAlert = false
      this.load()
    },
    runClick () {
      probeRunCheck(true).then((resp) => {
        if (resp.data.result.progress === 'running') {
          this.runAlert = true
        } else {
          const param = {testList: this.selectedItem}
          scenarioRun(param).then(() => {
            this.load()
          })
        }
      })
    },
    callRunCheck() {
      probeRunCheck(true).then((resp) => {
        if (resp.data.result.progress === 'running') {
          this.runCheck = true
        } else {
          this.runCheck = false
        }
        this.targetList = resp.data.result.targetTestList
        if (this.runCheck) {
          if (!this.interval) {
            this.interval = setInterval(() => {
              this.callRunCheck()
            }, 5000)
          }
        } else {
          clearInterval(this.interval)
          this.interval = null
          this.load(true)
        }
      })
    },
    load(intervalOut) {
      if (!intervalOut) {
        this.callRunCheck()
      }
      getTestList(true).then((resp) => {
        this.testList = resp.data.result
      })
      this.selectedItem = []

    },
    onSelectItem (item) {
      if (this.selectedItem.includes(item)) {
        this.selectedItem.splice(this.selectedItem.indexOf(item), 1)
      } else {
        this.selectedItem.push(item)
      }
    },
    resetSelectedItem () {
      this.selectedItem = []
    },
    onSelectAllItem () {
      if (this.selectedCount !== 1) {
        this.resetSelectedItem()
        this.testList.forEach(item => {
          this.selectedItem.push(item.id)
        })
      } else {
        this.resetSelectedItem()
      }
    },
  },
  data () {
    return {
      interval: null,
      runAlert: false,
      targetList: [],
      selectedItem: [],
      useHeaders: [
        {
          name: this.$t('testSetting.testKey'),
          // sortable: true,
          value: 'testKey'
        },
        {
          name: this.$t('testSetting.state'),
          // sortable: true,
          value: 'state'
        },
        {
          name: this.$t('testSetting.title'),
          // sortable: true,
          value: 'title'
        },
        {
          name: this.$t('testSetting.description'),
          // sortable: true,
          value: 'description'
        },
        {
          name: this.$t('testSetting.updatedAt'),
          // sortable: true,
          value: 'updatedAt'
        }
      ],
      testList: [],
      runCheck: null,
      listOption: {
        // pageNum: 1,
        // itemsPerPage: 50,
        sort: 'testKey'
      },
    }
  }
}
</script>

<style scoped lang="scss">
.test-setting {
  margin-top: 20px;
  margin-bottom: 20px;

  .info-line {
    margin-bottom: 20px;
    display: flex;
    justify-content: space-between;

    .info-box{
      margin-right: 30px;
      padding: 17px;
      .test-count {
        margin-left: 20px;
        display: flex;
        .select-count {
          color: #000;
          font-weight: 600;
          padding: 3px;

        }
      }
    }
    .btn-run {
      padding: 6px;
    }
  }

  .table-wrap {
    .thead {
      height: 55px;
    }

    .tbody {
      position: relative;
      max-height: calc(100% - 68px);
      padding-bottom: 12px;
      overflow: auto;
    }
    table {
      position: relative;
      width: 100%;
      border-spacing: 0px;

      thead {
        tr {
          th {
            height: 39px;
            font-size: 13px;
            font-weight: normal;
            background: #333333;
            color: #ffffff;
            padding: 9px 22px 7px 15px;
            vertical-align: bottom;
            text-align: left;
            line-height: 20px;
            transition: background-color 0.15s ease;
            white-space: nowrap;

            .icon {
              vertical-align: middle;
              margin: -1px 5px 1px 0;
              cursor: pointer;
            }

            &:first-child {
              border-radius: 7px 0 0 7px;
              border-left: 0;
              box-shadow: inset 1px 0 0 rgba(0, 0, 0, 0.15);
            }

            &.gap {
              padding: 0;
              width: 25px;
              border-bottom: none;
            }

            .sort {
              display: inline-block;
              width: 14px;
              height: 18px;
              padding: 1px 0;
              margin-top: -2px;
              margin-left: 2px;
              vertical-align: middle;
              border-radius: 4px;
              transition: background-color 0.15s ease,
              box-shadow 0.15s ease;

              i.icon {
                float: left;
                opacity: 0.2;
                transition: opacity 0.15s ease;
              }

              &.active {
                &.asc {
                  .icon--sort-asc {
                    opacity: 1;
                  }
                }

                &.desc {
                  .icon--sort-desc {
                    opacity: 1;
                  }
                }
              }

              &.active {
                background-color: #272727;
                box-shadow: 0 0 0 1px rgba(255, 255, 255, 0.146);
              }
            }
            &.th-testKey {
              padding-left: 13px;
            }

            &.th-regDate {
              text-align: right;
            }

            &.hover {
              .sort {
                background-color: #272727;
                box-shadow: 0 0 0 1px rgba(255, 255, 255, 0.146);
              }
            }

            &:last-child {
              border-radius: 0 7px 7px 0;
            }
          }
        }
      }
      tbody {
        tr {
          position: relative;
          height: 1px;

          td {
            height: 100%;
            text-align: left;
            font-size: 13px;
            line-height: 1.31;
            letter-spacing: normal;
            color: #444;
            word-break: break-all;
            border-bottom: 1px solid #ebebeb;
            vertical-align: top;

            .td-data {
              position: relative;
              height: 100%;
              padding: 17px 15px 17px 15px;
              box-sizing: border-box;
              &.state {
                color: #1C84FF;
                .circular-loader {
                  -webkit-animation: rotate 2s linear infinite;
                  animation: rotate 2s linear infinite;
                  width: 18px;
                  height: 18px;
                  -webkit-transform-origin: center center;
                  -ms-transform-origin: center center;
                  transform-origin: center center;
                  position: absolute;
                  top: 15px;
                  left: 60px;
                  margin: auto;
                }
                .loader-path {
                  stroke-dasharray: 150,200;
                  stroke-dashoffset: -10;
                  -webkit-animation: dash 1.5s ease-in-out infinite, color 6s ease-in-out infinite;
                  animation: dash 1.5s ease-in-out infinite, color 6s ease-in-out infinite;
                  stroke-linecap: round;
                }
                @-webkit-keyframes rotate {
                  100% {
                    -webkit-transform: rotate(360deg);
                    transform: rotate(360deg);
                  }
                }

                @keyframes rotate {
                  100% {
                    -webkit-transform: rotate(360deg);
                    transform: rotate(360deg);
                  }
                }
                @-webkit-keyframes dash {
                  0% {
                    stroke-dasharray: 1,200;
                    stroke-dashoffset: 0;
                  }
                  50% {
                    stroke-dasharray: 89,200;
                    stroke-dashoffset: -35;
                  }
                  100% {
                    stroke-dasharray: 89,200;
                    stroke-dashoffset: -124;
                  }
                }
                @keyframes dash {
                  0% {
                    stroke-dasharray: 1,200;
                    stroke-dashoffset: 0;
                  }
                  50% {
                    stroke-dasharray: 89,200;
                    stroke-dashoffset: -35;
                  }
                  100% {
                    stroke-dasharray: 89,200;
                    stroke-dashoffset: -124;
                  }
                }
                @-webkit-keyframes color {
                  0% {
                    stroke: #909090;
                  }
                  40% {
                    stroke: #909090;
                  }
                  66% {
                    stroke: #909090;
                  }
                  80%, 90% {
                    stroke: #909090;
                  }
                }
                @keyframes color {
                  0% {
                    stroke: #909090;
                  }
                  40% {
                    stroke: #909090;
                  }
                  66% {
                    stroke: #909090;
                  }
                  80%, 90% {
                    stroke: #909090;
                  }
                }
              }
              &.checkbox {
                padding-left: 34px;
              }

              .ui_checkbox {
                position: absolute;
                top: 15.5px;
                left: 8px;
                margin-left: 2px;
                margin-right: 1px;
              }
            }

            &.gap {
              width: 25px;
              border-bottom: none;
            }

            &.td-regDate {
              text-align: right;

              .td-data {
                margin-right: 20px;
                padding-right: 6px;
              }
            }
          }
        }
      }
    }




  }
}
</style>
